import {combineReducers} from 'redux';
import invoices from './invoices.reducer';

const invoicesReducer = combineReducers({
	invoices,
});

export default invoicesReducer;